import { createSlice } from '@reduxjs/toolkit';

export const shiftGeneratorSlice = createSlice({
  name: 'shiftGenerator',
  initialState: {
    isGenerating: false,
    lastGeneratedResult: null,
    request_shift_list: [],
  },
  reducers: {
    setGenerating: (state, { payload }) => {
      state.isGenerating = payload;
    },
    setLastGeneratedResult: (state, { payload }) => {
      state.lastGeneratedResult = payload;
    },
    setRequestShiftList: (state, { payload }) => {
      state.request_shift_list = payload;
    },
  },
});

export const { setGenerating, setLastGeneratedResult, setRequestShiftList } =
  shiftGeneratorSlice.actions;
